import { Color } from "bambu";
import Stateless from "component/Stateless";
import * as React from "react";
import Page from "view/page/Page";
import { Props } from "wasabi-common";
import Objects from "wasabi-common/lib/types/Objects";

import MessageView from "../component/layout/box/MessageView";
import language from "../data/source/language/language";

export default class NotFound extends Stateless<{}> {
  public static messages = {
    header: "Not Found",
    title: "Error",
    message: "Page/Module not reachable now.",
  };

  public render(): JSX.Element {
    const messages = NotFound.getMessages();
    return (
      <Page hasBox={false} header={messages.header}>
        <MessageView color={Color.danger} header={messages.title}>
          {messages.message}
          <br />
          {"Reloading in 3 seconds..."}
        </MessageView>
      </Page>
    );
  }

  public static getMessages() {
    const error: Props<any> = (language.get("not_found") || {}) as Props<any>;
    return Objects.mergeDefaults(NotFound.messages, error);
  }

  componentDidMount() {
    if (process.env.NODE_ENV !== "development") {
      setTimeout(() => {
        window.location.reload(true);
      }, 3000);
    }
  }
}
